// extracted by mini-css-extract-plugin
export default {"box":"Card_box__gRPMr","icon":"Card_icon__iUnci","heading":"Card_heading__sImN+","text":"Card_text__s64dz"};